import React from 'react';
import PropTypes from 'prop-types';

import NumberInputComponent from './components/numberInputComponent';

const UndergraduateStudents = ({ onChange, initialValue }) => (
  <NumberInputComponent
    value={initialValue.value}
    onChange={(e, { value }) => {
      onChange(e, { value });
    }}
    name="Transfer-Undergraduate-Students"
  />
);

UndergraduateStudents.propTypes = {
  onChange: PropTypes.func,
  initialValue: PropTypes.object,
};
export default UndergraduateStudents;
